import { VideoSite } from '@tmdb-graphql-api/schema/types';

export const baseUrls = {
  [VideoSite.Vimeo]: 'https://vimeo.com/' as const,
  [VideoSite.YouTube]: 'https://www.youtube.com/watch?v=' as const,
};
